// @core/api/endpoints/admin/list_audit_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditLogsResponse,
} from '../../../types/admin';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/admin';

/**
 * List audit logs across all services
 * Returns a unified, paginated view of audit logs aggregated from all services. Supports filtering by date range, action type, actor, and resource.
 */
export async function ListAuditLogs(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditLogsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin/audit-logs`;
  const requestOptions = options;
  return client.get<ListAuditLogsResponse>(requestPath, { ...requestOptions, params });
}
